import ChargeHelper from 'features/Charge/chargeHelper';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import CustomDateRangePicker, {
  dateFilter,
  getDateFilterOption,
} from 'general/components/Others/CustomDateRangePicker';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import UIHelper from 'general/helpers/UIHelper';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

ChargeDriverListFilterView.propTypes = {
  onCancel: PropTypes.func,
  onApply: PropTypes.func,
};

function ChargeDriverListFilterView({ onCancel, onApply, closeDropdown }) {
  // MARK: ---- PROPERTIES ----
  const [filterQ, setFilterQ] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [filterPricingType, setFilterPricingType] = useState('');
  const [filterDateFilter, setFilterDateFilter] = useState(dateFilter.tatCaThoiGian);
  const [filterFrom, setFilterFrom] = useState('');
  const [filterTo, setFilterTo] = useState('');
  const [filterTransactionDateFilter, setFilterTransactionDateFilter] = useState(dateFilter.tatCaThoiGian);
  const [filterTransactionFrom, setFilterTransactionFrom] = useState('');
  const [filterTransactionTo, setFilterTransactionTo] = useState('');

  useEffect(() => {
    setFilterQ(ChargeHelper.Filter.chargeDriverList.q);
    setFilterStatus(ChargeHelper.Filter.chargeDriverList.status);
    setFilterPricingType(ChargeHelper.Filter.chargeDriverList.pricingType ?? '');
    setFilterDateFilter(ChargeHelper.Filter.chargeDriverList.dateFilter ?? dateFilter.tatCaThoiGian);
    setFilterFrom(ChargeHelper.Filter.chargeDriverList.from ?? '');
    setFilterTo(ChargeHelper.Filter.chargeDriverList.to ?? '');
    setFilterTransactionDateFilter(ChargeHelper.Filter.chargeDriverList.transactionDateFilter ?? dateFilter.tatCaThoiGian);
    setFilterTransactionFrom(ChargeHelper.Filter.chargeDriverList.transactionFrom ?? '');
    setFilterTransactionTo(ChargeHelper.Filter.chargeDriverList.transactionTo ?? '');
  }, []);

  // MARK: ---- METHODS ----
  const handleApplyFilter = () => {
    ChargeHelper.Filter.chargeDriverList = {
      ...ChargeHelper.Filter.chargeDriverList,
      status: filterStatus,
      q: filterQ,
      pricingType: filterPricingType,
      from: filterFrom,
      to: filterTo,
      dateFilter: filterDateFilter,
      transactionFrom: filterTransactionFrom,
      transactionTo: filterTransactionTo,
      transactionDateFilter: filterTransactionDateFilter,
    };
    if (onApply) onApply();
    if (closeDropdown) closeDropdown();
  };
  const handleClearFilter = () => {
    ChargeHelper.Filter.chargeDriverList = {
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      q: '',
      status: '',
      pricingType: '',
      from: '',
      to: '',
      dateFilter: dateFilter.tatCaThoiGian,
      transactionFrom: '',
      transactionTo: '',
      transactionDateFilter: dateFilter.tatCaThoiGian,
    };
    if (onCancel) onCancel();
    if (closeDropdown) closeDropdown();
  };

  return (
    <div className="py-4">
      <div className="row m-0 px-2">
        {/* tim kiem */}
        <div className="col-12 mb-4 px-2">
          <KTFormSearch
            name="search_filter"
            placeholder="Theo mã khách hàng, họ và tên, số điện thoại, email, biển số xe..."
            value={filterQ}
            onSubmit={(text) => {
              setFilterQ(text);
            }}
          />
        </div>
        {/* trang thai */}
        <div className="col-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Trạng thái')}
          <KTBSDropdown
            name="status_filter"
            toggleElement={
              <button
                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                type="button"
              >
                {_.find(
                  ChargeHelper.Data.chargeDriverStatusOptions,
                  (item) => item.value === filterStatus
                )?.name ?? 'Tất cả'}
              </button>
            }
            selectedValue={filterStatus}
            dropdownMenuItems={[
              { name: 'Tất cả', value: '' },
              ...ChargeHelper.Data.chargeDriverStatusOptions,
            ]}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            onChange={(value) => setFilterStatus(value)}
            isDropdownForm={true}
          />
        </div>
        {/* loai gia sac */}
        <div className="col-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Loại giá sạc')}
          <KTBSDropdown
            name="pricingType_filter"
            toggleElement={
              <button
                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                type="button"
              >
                {_.find(
                  ChargeHelper.Data.chargeDriverPricingTypeOptions,
                  (item) => item.value === filterPricingType
                )?.name ?? 'Tất cả'}
              </button>
            }
            selectedValue={filterPricingType}
            dropdownMenuItems={[
              { name: 'Tất cả', value: '' },
              ...ChargeHelper.Data.chargeDriverPricingTypeOptions,
            ]}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            onChange={(value) => setFilterPricingType(value)}
            isDropdownForm={true}
          />
        </div>
        {/* thoi gian tao */}
        <div className="col-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Thời gian tạo')}
          <CustomDateRangePicker
            toggleElementBorderRadius={5}
            initialValue={filterDateFilter}
            filterComponent={{ from: filterFrom, to: filterTo }}
            onPressSave={(selectedValue, startDate, endDate) => {
              setFilterDateFilter(selectedValue);
              setFilterFrom(startDate);
              setFilterTo(endDate);
            }}
          />
        </div>
        {/* ky giao dich */}
        <div className="col-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Kỳ giao dịch')}
          <CustomDateRangePicker
            toggleElementBorderRadius={5}
            initialValue={filterTransactionDateFilter}
            filterComponent={{ from: filterTransactionFrom, to: filterTransactionTo }}
            onPressSave={(selectedValue, startDate, endDate) => {
              setFilterTransactionDateFilter(selectedValue);
              setFilterTransactionFrom(startDate);
              setFilterTransactionTo(endDate);
            }}
          />
        </div>
      </div>

      {/* actions */}
      <div
        className="px-4 pt-4 pb-0 d-flex align-items-center justify-content-end gap-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Xóa bộ lọc', handleClearFilter)}
        {UIHelper.buildGreenButton('Áp dụng', handleApplyFilter)}
      </div>
    </div>
  );
}

export default ChargeDriverListFilterView;
